<template>
  <div style="height: 100%;">
      <h3 class="titit">拆卸报警</h3>
      <div style="width:95%;height:75%;position: relative;">
        <dv-scroll-board v-if="hasData" :config="config" style="width:100%;height:100%" />
        <div v-else class="no-data">
          <span>暂无数据</span>
        </div>
      </div>
  </div>
</template>

<script>
import { left2Data } from '@/api/ksharge'

export default {
data () {
  return {
    loading: false,
    config: {
      header: ['表号', '姓名', '地址', '时间'],
      data: [],
      rowNum: 5,
      waitTime: 2000,
      headerBGC: 'rgba(220, 20, 60, 0.25)',

      columnWidth: [140, 140, 200, 180]
    }
  }
},
computed: {
  hasData () {
    return this.config.data && this.config.data.length > 0
  }
},
mounted () {
  this.fetchAlarmData()
},
methods: {
  async fetchAlarmData () {
    this.loading = true
    try {
      const token = this.$store.state?.print?.goodsForeNo?.token || sessionStorage.getItem('token')
      if (!token) {
        console.warn('缺少 token，无法获取拆卸报警数据')
        return
      }
      const params = {
        token,
        alarm_type: '拆卸报警'
      }
      const res = await left2Data(params)
      console.log('拆卸报警数据：', res)
      const responseData = res?.data?.data || res?.data
      if (res?.data?.status === 'success' && responseData) {
        const alarms = Array.isArray(responseData.alarms) ? responseData.alarms : []
        const tableData = alarms.map(item => ([
          item.meter_id || '-',
          this.wrapTooltipCell(item.username),
          this.wrapTooltipCell(item.address),
          item.alarm_time || '-'
        ]))
        const rowNum = Math.max(1, Math.min(tableData.length || 5, 7))
        this.config = {
          ...this.config,
          data: tableData,
          rowNum
        }
      }
    } catch (error) {
      console.error('获取拆卸报警数据失败:', error)
    } finally {
      this.loading = false
    }
  },
  wrapTooltipCell (value) {
    const text = value || '-'
    if (text === '-') {
      return text
    }
    const safeText = this.escapeHtml(text)
    return `<span class="cell-tooltip" title="${safeText}">${safeText}</span>`
  },
  escapeHtml (str) {
    if (!str) {
      return ''
    }
    return str
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;')
  }
}
}
</script>

<style lang="less">
.titit{
text-align: center;
font-size: 16px;
font-weight: bold;
color: #fff;
margin: 10px;
background: linear-gradient(90deg, #361d23, #406779);
    -webkit-background-clip: text;
    background-clip: text;
    -webkit-text-fill-color: transparent;
    text-shadow: 0 2px 10px rgba(255, 0, 0, 0.3);
}
.dv-scroll-board .cell-tooltip{
display: inline-block;
width: 100%;
overflow: hidden;
text-overflow: ellipsis;
white-space: nowrap;
}
.no-data {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  color: #999;
  font-size: 14px;
}
</style>